import { render, staticRenderFns } from "./certification.vue?vue&type=template&id=65a001db&scoped=true&"
import script from "./certification.vue?vue&type=script&lang=js&"
export * from "./certification.vue?vue&type=script&lang=js&"
import style0 from "./certification.vue?vue&type=style&index=0&id=65a001db&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a001db",
  null
  
)

export default component.exports